import { Group } from '@types';
import { User } from '@types';

export type UserSearchHit = Pick<User, 'displayName' | 'username' | 'photoUrl' | 'numFollowers'> & {
  objectID: string;
  'hometown.displayName': User['hometown']['displayName'];
};

export type UserSearchResult = Pick<
  User,
  'userId' | 'displayName' | 'username' | 'photoUrl' | 'numFollowers'
> & {
  hometown: Pick<User['hometown'], 'displayName'>;
};

export type GroupSearchHit = Pick<
  Group,
  'displayName' | 'description' | 'photoUrl' | 'numMembers' | 'verified'
> & {
  objectID: string;
};

export type GroupSearchResult = Pick<
  Group,
  'groupId' | 'displayName' | 'description' | 'photoUrl' | 'numMembers' | 'verified'
>;
